// Feature flag for the public new-patient intake page (issues #150, #177 §4).
//
// The page works end to end through the #166 execution proxy and the token-verifying `intake-submit` bot,
// but only a deployment that has DEPLOYED that bot (and the proxy's intake setting + the narrow client's
// grant) can accept a submission. So the `/intake` route — and the chart's "Text intake link" card, which
// would otherwise text a live link — stay behind this flag, OFF by default, until an operator turns it on
// as part of the arming steps in infra/azure/README.md.

/** True only when `VITE_ENABLE_PUBLIC_INTAKE` is explicitly `"true"`. Off for every other value. */
export function isPublicIntakeEnabled(env: { VITE_ENABLE_PUBLIC_INTAKE?: string } = import.meta.env): boolean {
  return env.VITE_ENABLE_PUBLIC_INTAKE === 'true';
}
